import logdown from 'logdown';

export class Logger {
  logger = {
    log: () => {
      // do nothing.
    },
    info: () => {
      // do nothing.
    },
    warn: () => {
      // do nothing.
    },
    error: () => {
      // do nothing.
    },
  };

  namespace = '';

  constructor(namespace) {
    this.namespace = namespace;

    if (!window._env_.ENABLE_LOGGING) {
      return;
    }

    this.logger = logdown(namespace);
    this.logger.state.isEnabled = true;
  }

  log(...args) {
    this.logger.log(...args);
  }

  info(...args) {
    this.logger.info(...args);
  }

  warn(...args) {
    this.logger.warn(...args);
  }

  error(...args) {
    this.logger.error(...args);
  }
}
